module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "z-big-select",
    class: {
      'focus': _vm.focus, 'no-label': (_vm.$props.label ? false : true), 'has-value': _vm.$props.value, 'has-error': _vm.error && _vm.error.length, 'disabled': _vm.$props.disabled, 'readonly': _vm.$props.readonly
    }
  }, [_c('div', {
    staticClass: "z-big-select-container",
    class: {
      'active': _vm.focus
    },
    on: {
      "click": _vm.onFocus
    }
  }, [_c('div', {
    staticClass: "icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$props.icon)
    }
  }), _c('div', {
    staticClass: "z-big-select-label-container"
  }, [_c('label', {
    staticClass: "z-big-select-label",
    class: {
      'has-value': (_vm.displayLabel) ? true: false
    }
  }, [_vm._v(_vm._s(_vm.$props.label))]), _c('label', {
    staticClass: "z-big-select-display-label"
  }, [_vm._v(_vm._s(_vm.displayLabel))])]), _c('div', {
    staticClass: "z-big-select-input can-scroll"
  }, [_vm._t("default")], 2), _vm._m(0), _c('div', {
    staticClass: "z-big-select__clear",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  })]), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-big-select__arrow"
  }, [_c('i', {
    staticClass: "fas fa-chevron-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bf02784","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZBigSelect.vue
// module id = 1207
// module chunks = 0